module.exports = __webpack_public_path__ + "img/36503-028.5abaaf32.jpg";